/** Typed route table — the single place route paths are defined. */
export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  settings: '/settings',
  call: '/call/:bookingId',
  checkIn: '/check-in',
  findTherapist: '/find-therapist',
  book: '/book/:therapistUserId',
  paymentSuccess: '/booking/:bookingId/paid',
  paymentCancelled: '/booking/:bookingId/payment-cancelled',
  terms: '/terms',
  privacy: '/privacy',
} as const;

export type AppRoute = (typeof routes)[keyof typeof routes];

/** Builds the concrete /call/:bookingId path for a given booking. */
export function callRoute(bookingId: string): string {
  return `/call/${bookingId}`;
}

/** Builds the concrete /book/:therapistUserId path for a given therapist. */
export function bookRoute(therapistUserId: string): string {
  return `/book/${therapistUserId}`;
}

// No builder functions for paymentSuccess/paymentCancelled — nothing in
// this app navigates to them directly. The URLs are built server-side
// (PaymentsService, from PUBLIC_APP_URL) as Stripe Checkout's
// success_url/cancel_url; these route entries only exist so AppRouter can
// render something when Stripe redirects the browser back here.
